module.exports = "data:image/gif;base64,R0lGODlhAwAFAIAAAP///0lISSH5BAAAAAAALAAAAAADAAUAAAIFDBCWi1cAOw=="